
import Storage from './Storage';
import { Guardian, User } from '@xaamin/guardian';

class AuthManager {
  constructor() {
    this._isAuthenticated = false;
  }

  async setData(data) {
    this.data = data;

    !!data.user && this._mapUserToGuardian();

    await Storage.put('facturotopia', data);
  }

  _mapUserToGuardian() {
    const data = this.getUser();

    const user = new User({
      ...data,
      roles: data.roles || [],
      permissions: data.permissions || [],
  });

    Guardian.setUser(user);
  }

  getData(data) {
    return this.data;
  }

  isAuthenticated() {
    const token = this.data ? this.data.token : null;

    this._isAuthenticated = token !== null && token !== undefined;

    return this._isAuthenticated;
  }

  getUser() {
    if (this.isAuthenticated()) {
      const { user, cliente } = this.data;

      return { ...user, cliente };
    }

    return null;
  }

  getToken() {
    if (this.isAuthenticated()) {
      return this.data.token;
    }

    return null;
  }

  async logout() {
    this.data = null;
    this._isAuthenticated = false;

    await Storage.remove('unstated::root');
    await Storage.remove('facturotopia');
  }
}

export default AuthManager;
